// extracted by mini-css-extract-plugin
export var addToCartStyle = "single-product-module--addToCartStyle--bif7l";
export var breadcrumb = "single-product-module--breadcrumb--V-ipc";
export var container = "single-product-module--container--l80OM";
export var header = "single-product-module--header--igsPZ";
export var labelFont = "single-product-module--labelFont--lFGps";
export var metaSection = "single-product-module--metaSection--QsmII";
export var noImagePreview = "single-product-module--noImagePreview--RDACZ";
export var optionsWrapper = "single-product-module--optionsWrapper--VgB+4";
export var priceValue = "single-product-module--priceValue--+HpIX";
export var productBox = "single-product-module--productBox--5kQGM";
export var productDescription = "single-product-module--productDescription--sJDYe";
export var productImageList = "single-product-module--productImageList--qmADp";
export var productImageListItem = "single-product-module--productImageListItem--JSRQk";
export var productImageWrapper = "single-product-module--productImageWrapper--qkaFK";
export var scrollForMore = "single-product-module--scrollForMore--tpEBa";
export var selectVariant = "single-product-module--selectVariant--bNwtg";
export var tagList = "single-product-module--tagList--XxmVl";
export var visuallyHidden = "single-product-module--visuallyHidden--e7CCa";